import React from 'react'
import PageList from '../cn/pageList'

const CnHome = () => <PageList />

export default CnHome
